<template>
  <el-row :gutter="10" style="height:100%">
    <el-col :span="4" style="height:100%">
      <div  ref="left" style="height:100%;">
        <!--<el-card class="box-card" v-for="w in allWidgets" :widget="w.id" :key="w.name">
          {{w.name}}<span @click="removeWidget(w)" v-if="!w.builtIn && editmode" style="float: right;cursor: pointer;"><i class="fa fa-close fa-lg"></i></span>
        </el-card>-->
        <div class="default-widget widget-container" ref="left1" v-show="!hideDefaultLayout">
          <el-card class="box-card" v-for="w in defaultWidgets" :widget="w.id" :key="w.name" >
            <i class="fa fa-th fa-lg"></i>{{w.name}}
          </el-card>
        </div>
        <div class="custom-widget widget-container" ref="left2" v-show="!hideCustomLayout">
          <el-card class="box-card" v-for="w in widgets" :ref="w.id" :info="w" :widget="w.id" :key="w.name">
            <i class="fa fa-list-ul fa-lg"></i>{{w.name}}<span @click="removeWidget(w)" v-if="!w.builtIn && editmode" style="float: right;cursor: pointer;"><i class="fa fa-close fa-lg"></i></span>
          </el-card>
        </div>
      </div>
    </el-col>
    <el-col :span="15" style="height:100%;position:relative">
      <div class="empty-msg" v-if="isEmpty">将布局拖动到此处</div>
      <div class="designer-container" ref="center">

      </div>
    </el-col>
    <el-col :span="5" style="height:100%;overflow:auto">
      <div class="editor-container" ref="right">
        <h3 v-if="!!currentComp" style="padding-left:20px">{{currentComp.widgetName}}</h3>
        <component v-if="!!currentComp"
                   :is="currentComp.editorParams && currentComp.editorParams.xtype"
                   :data="currentComp.data"
                   :params="currentComp.editorParams">
        </component>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import defaultWidgets from './widgets';
  import itemWrapperDesigner from './item-wrapper-designer'
  import itemWrapperEditor from './item-wrapper-editor'
  import Vue from 'vue'
  export default {
    name:"layout-manager",
    props:{
      widgets:Array,
      dataItems:Array,
      editmode:Boolean,
      hideDefaultLayout:{
        type:Boolean,
        defaultValue:false
      },
      hideCustomLayout:{
        type:Boolean,
        defaultValue:false
      }
    },
    data() {
      this.initWidgets();
      return {
        compMap: {},
        currentComp: {},
        defaultWidgets:defaultWidgets,
        ready:false,
        isEmpty:true
      }
    },
    mounted() {
      let me = this;
      PF.loadCss("/assets/js/dragula/dragula.min.css");
      PF.requireJs("/assets/js/dragula/dragula.min.js",()=>{
        me.$nextTick(() => {
          me.drake=dragula([me.$refs.left1,me.$refs.left2, me.$refs.center], {
            isContainer(el,target){
              //组件里面的有这个样式的div可以拖放组件。
              return $(el).is(".dragula-container") && !el.contains(target)
            },
            copy(el, source) {
              return $(source).is(".widget-container");
            },
            accepts(el, target, source, sibling) {
              return !$(target).is(".widget-container");
            },
            removeOnSpill: true
          }).on("drop", (item, parent, source, currentSibling) => {
            if ($(source).is(".widget-container")) {
              if($(parent).is(".designer-container") || $(parent).is(".dragula-container")){
                me.addWidget(item);
              }
            }
            me.$emit("change");
          }).on("remove",(el,container,source)=>{
            let wid=$(el).attr("wid");
            delete me.compMap[wid];
            $(el).find("div[wid]").each(function(){
              let wid=$(this).attr("wid")
              delete me.compMap[wid];
            });
            if(_.isEmpty(me.compMap))me.isEmpty=true;
            me.$emit("change");
          });
          me.loadData();
          me.ready=true;
        });
      });
    },
    methods: {
      initWidgets() {
        if(this.widgets){
          this.widgets.forEach(w=>{
            w.initData=_.clone(w);
            delete w.initData.id;
            w.xtype="item-wrapper";
            w.editorComp=itemWrapperEditor;
            w.designerComp=itemWrapperDesigner;

          })
        }
      },
      getWidget(id) {
        return _.find(defaultWidgets,{id:id}) || _.find(this.widgets,{id:id})
      },
      loadData() {
        let me = this;
        if(!me.dataItems)return;
        me.dataItems.forEach(item=>{
          me.addItem(item,me.$refs.center);
        });
      },
      removeWidget(w){
        this.$emit("removeWidget",w);
      },
      createNewComponent(widget,data) {
        let me = this;
        let id = $uuid();
        let doActive=!data;
        if(_.isString(widget)){
          widget=me.getWidget(widget);
        }
        data=_.assign({},_.cloneDeep(widget.initData),data);
        data.id = data.id || id;
        data.widgetId=widget.id;
        let comp = {
          xtype: widget.xtype,
          widgetId:widget.id,
          widgetName:widget.name,
          designerParams: {
            xtype: widget.designerComp.name
          },
          editorParams: {
            xtype: widget.editorComp.name
          },
          data: data
        }
        if(doActive)me.currentComp = comp;
        me.compMap[id] = comp;
        let Designer = Vue.extend(widget.designerComp);
        let designer = new Designer({
          propsData: {
            params: data,
            data: {}
          }
        });
        designer.$on("addItems",(items,el)=>{
          //有子组件的时候，designer发一个事件出来。
          if(!items)return;
          items.forEach(item=>me.addItem(item,el));
        });
        designer.$mount();
        comp.designer = designer;
        $(designer.$el).attr("wid",id).click((e) => {
          e.stopPropagation();
          me.currentComp = comp;
        });
        me.isEmpty=false;
        return designer;
      },
      addWidget(el) {
        let me = this;
        let widgetId = $(el).attr("widget");
        let designer = me.createNewComponent(widgetId);
        $(designer.$el).insertAfter(el);
        $(el).remove();
      },
      addItem(item,el){
        //把组件定义数据渲染加载到el的位置。同时渲染子组件。
        let me=this;
        let widget = me.getWidget(item.widgetId);
        let designer = me.createNewComponent(widget,item);
        $(designer.$el).appendTo(el);
      },
      getCompData(comp){
        let me=this;
        let containers=$(comp.designer.$el).find(".dragula-container");
        function isOwn(ct){ //是本组件的容器而不是子组件的。
          return $(ct).closest("[wid]")[0]===comp.designer.$el;
        }
        let data=_.cloneDeep(comp.data);
        containers.each(function(){
          let ct=this;
          if(isOwn(ct)){
            let childNodes = ct.childNodes;
            if (!childNodes) return;
            let items=_.map(childNodes,node=>{
              let wid=$(node).attr("wid");
              let c=me.compMap[wid];
              return c && me.getCompData(c);
            });
            if(comp.designer.setContainerData){
              //设计器自己把数据塞到data里面合适的地方.
              comp.designer.setContainerData(ct,items,data);
            }
          }
        });
        data.xtype = comp.xtype;
        data.widgetName = comp.widgetName;
        return data;
      },
      getData(){
        let me = this;
        let childNodes = me.$refs.center.childNodes;
        if (!childNodes) return [];
        return _.map(childNodes, node => {
          let wid = $(node).attr("wid");
          let comp = me.compMap[wid];
          return me.getCompData(comp);
        });
      },
      clear() {
        _.each(this.compMap,comp=>{
          if(comp.designer){
            comp.designer.$destroy();
            $(comp.designer.$el).remove();
          }
        });
        this.currentComp={};
      },
    },
    watch: {
      currentComp(comp, oldComp) {
        if (oldComp && oldComp.designer) {
          $(oldComp.designer.$el).removeClass("designer-active");
        }
        if (comp && comp.designer) {
          $(comp.designer.$el).addClass('designer-active');
        }
      },
      dataItems(newValue){
        if(!this.ready)return;
        this.clear();
        this.compMap={};
        this.loadData();
      },
      widgets() {
        this.initWidgets();
      }
    },
    computed:{
      allWidgets(){
          return defaultWidgets.concat(this.widgets);
      }
    },

    beforeDestroy(){
      // _.each(this.compMap,comp=>{
      //   if(comp.designer)comp.designer.$destroy();
      // });
      this.clear()
      if(this.drake)this.drake.destroy();
    }
  }
</script>
<style>
.widget-container .el-card__body {
  padding: 10px !important;
}
.editor-container .el-table .cell{
  padding-left: 2px !important;
  padding-right: 1px !important;
}

</style>
<style scoped>

  .designer-container{
    height:100%;
    border:1px solid #ccc;
  }
  .custom-widget{
    overflow-y: auto;
    height: calc(100% - 140px);
  }
  .default-widget{
    padding-bottom: 10px;
  }
  .empty-msg{
    text-align: center;
    position: absolute;
    width: 100%;
    top: 50%;
    font-size: 24px;
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/layout/designer/manager.vue